import request from '@/utils/request'

//打卡列表
export function getAttendanceList(data) {
    return request({
        url: '/backend/ClockIn/getAttendanceList',
        method: 'post',
        data: data
    })
}

//创建修改打卡
export function createAttendance(data) {
    return request({
        url: '/backend/ClockIn/createAttendance',
        method: 'post',
        data: data
    })
}

//获取打卡详情基本信息
export function getAttendanceInfo(data) {
    return request({
        url: '/backend/ClockIn/getAttendanceInfo',
        method: 'post',
        data: data
    })
}

//获取打卡作业列表
export function getTaskList(data) {
    return request({
        url: '/backend/ClockIn/getAttendanceTaskList',
        method: 'post',
        data: data
    })
}
//获取打卡作业列表
export function getPeriodList(data) {
    return request({
        url: '/backend/ClockIn/getPeriodList',
        method: 'post',
        data: data
    })
}



//获取学员管理列表
export function getStudentList(data) {
    return request({
        url: '/backend/ClockIn/getStudentList',
        method: 'post',
        data: data
    })
}

//获取学员详情-学员打卡信息
export function stuClockInfoList(data) {
    return request({
        url: '/backend/ClockIn/stuClockInfoList',
        method: 'post',
        data: data
    })
}

//获取学员详情-学员打卡列表
export function stuClockContentList(data) {
    return request({
        url: '/backend/ClockIn/stuClockContentList',
        method: 'post',
        data: data
    })
}

//获取学员详情-学员打卡删除
export function stuClockDelete(data) {
    return request({
        url: '/backend/ClockIn/stuClockDelete',
        method: 'post',
        data: data
    })
}

//获取数据分析列表
export function dataAnalysisList(data) {
    return request({
        url: '/backend/ClockIn/dataAnalysisList',
        method: 'post',
        data: data
    })
}

//获取日记列表
export function getAttendanceRecordList(data) {
    return request({
        url: '/backend/ClockIn/getAttendanceRecordList',
        method: 'post',
        data: data
    })
}

//编辑打卡
export function editAttendanceTask(data) {
    return request({
        url: '/backend/ClockIn/editAttendanceTask',
        method: 'post',
        data: data
    })
}

//删除日记
export function delAttendanceRecord(data) {
    return request({
        url: '/backend/ClockIn/delAttendanceRecord',
        method: 'post',
        data: data
    })
}

//打卡成功学员列表（证书学员列表）
export function getCertStudentList(data) {
    return request({
        url: '/backend/ClockIn/getCertStudentList',
        method: 'post',
        data: data
    })
}
//批量设置非灵动生活订单的返现状态
export function updateCashBackStatus(data) {
    return request({
        url: '/backend/ClockIn/updateCashBackStatus',
        method: 'post',
        data: data
    })
}

//获取课程二维码链接
export function getObjectQrcodeUrl(data) {
    return request({
        url: '/backend/ClockIn/getObjectQrcodeUrl',
        method: 'post',
        data: data
    })
}